import { NavParams, ModalController } from '@ionic/angular';
import { Component, OnInit } from '@angular/core';
import { EnumGenericRoleActionAlerts } from '@pages/BasePage';
import { IFileModel } from '@models/Common';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { EnumRequestsCardIdProject } from '@models/ProjectSettings';

@Component({
    selector: 'app-upload-requested-cards',
    templateUrl: './upload-requested-cards.component.html',
    styleUrls: ['./upload-requested-cards.component.scss'],
})
export class UploadRequestedCardsComponent implements OnInit {

    public Users: any[] = [];
    private onUpload: Function;
    private onChange: Function;
    private onGenerateLetter: Function;
    private onGenerateZIP: Function;
    public File: IFileModel;

    public FileFormatsAllowed: string = '.xlsx';

    public IdProject: EnumRequestsCardIdProject = null;
    public EnumRequestsCardIdProject = EnumRequestsCardIdProject;

    public Form: FormGroup;

    constructor(private NavParams: NavParams,
        private ModalController: ModalController
    ) {

        this.Users = this.NavParams.get('users') || this.Users;

        console.log(this.Users);

        this.onUpload = this.NavParams.get('onUpload') || null;
        this.onChange = this.NavParams.get('onChangeFile') || null;
        this.onGenerateLetter = this.NavParams.get('onGenerateLetter') || null;
        this.onGenerateZIP = this.NavParams.get('onGenerateZIP') || null;

        this.FileFormatsAllowed = this.NavParams?.get('formatsAllowed') || '.zip';

        this.IdProject = this.NavParams?.get('idProject') || EnumRequestsCardIdProject.MicroIO;

        const processNumber = String(this.NavParams?.get('processNumber') || '').padStart(8, '0');

        this.Form = new FormGroup({
            ProcessNumber: new FormControl({ value: processNumber, disabled: true }, [Validators.required]),
            Name: new FormControl(null, []),
            Observation: new FormControl(null, [])
        })
    }

    ngOnInit() { }

    Close() {

        // using the injected ModalController this page
        // can "dismiss" itself and optionally pass back data
        this.ModalController.dismiss(null, EnumGenericRoleActionAlerts.Close);
    }




    async OnChangeFile(file: any) {

        console.log(file);

        if (this.onChange)
            this.File = await this.onChange(file);

    }

    /**
     * 
     * @param ev 
     */
    async OnGenerateLetter(ev?: any) {

        if (this.onGenerateLetter) this.onGenerateLetter();
    }

    /**
     * 
     * @param ev 
     */
    async OnGenerateZIP(ev?: any) {

        if (this.onGenerateZIP) this.onGenerateZIP();
    }

    async OnUploadFile(ev: any) {


        if (this.onUpload) {

            if (this.Form.invalid) {
                console.log("complete os dados em falta");

                return;
            }

            const details = {
                Name: this.Form.get('Name').value || '',
                ProcessNumber: this.Form.get('ProcessNumber').value || '',
                Observation: this.Form.get('Observation').value || '',
            }
            const r = await this.onUpload(this.Users, this.File, details);

            if (r)
                this.ModalController.dismiss(null, EnumGenericRoleActionAlerts.Confirm);
        }
    }

}
